import { Modal, Button } from 'antd';
import { useAuth as useOidcAuth } from 'react-oidc-context';
import { useSession } from '../../context/SessionContext';
import { useAuth } from '../../context/AuthProvider';

const Expiration = () => {
  const { sessionExpired, setSessionExpired, networkError, setNetworkError } = useSession();
  const { logout } = useAuth();
  const { user, removeUser, signoutRedirect, clearStaleState } = useOidcAuth();

  const SignOut = async () => {
    logout();
    try {
      removeUser();
      await signoutRedirect({
        id_token_hint: user?.id_token,
        post_logout_redirect_uri: 'http://localhost:3000/',
      });
      clearStaleState();
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  return (
    <>
      <Modal
        open={sessionExpired}
        centered
        closable={false}
        maskClosable={false}
        footer={[
          <Button
            key="ok"
            type="primary"
            className="bg-green-600 hover:bg-green-700"
            onClick={() => {
              setSessionExpired(false);
              SignOut();
            }}
          >
            Login Again
          </Button>,
        ]}
      >
        <div className="text-center py-3">
          <h2 className="text-xl font-semibold text-gray-800">Session Expired</h2>
          <p className="text-gray-600 mt-2">You’ve been logged out due to inactivity or token expiration.</p>
        </div>
      </Modal>

      <Modal
        open={networkError}
        centered
        closable={false}
        maskClosable={false}
        footer={[
          <Button
            key="retry"
            type="primary"
            className="bg-green-600 hover:bg-green-700"
            onClick={() => {
              setNetworkError(false);
              window.location.reload();
            }}
          >
            Retry
          </Button>,
        ]}
      >
        <div className="text-center py-3">
          <h2 className="text-xl font-semibold text-gray-800">Network Error</h2>
          <p className="text-gray-600 mt-2">
            Unable to connect to the server. Please check your internet connection or try again.
          </p>
        </div>
      </Modal>
    </>
  );
}

export default Expiration;
